import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import createAffiliatePortalInstance from "../../api/AffiliatePortalInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import type {
  ApiSuccessEnvelope,
  PortalMeResponseData,
} from "../../types/affiliates";

const fetchPortalMe = async (): Promise<PortalMeResponseData> => {
  const instance = createAffiliatePortalInstance();
  const response = await instance.get<ApiSuccessEnvelope<PortalMeResponseData>>(
    API_ROUTES.AFFILIATE_PORTAL_ME,
  );
  return response.data.data;
};

export const usePortalMe = (
  enabled = true,
): UseQueryResult<PortalMeResponseData, Error> =>
  useQuery<PortalMeResponseData, Error>({
    queryKey: ["affiliate-portal", "me"],
    queryFn: fetchPortalMe,
    enabled,
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
    retry: false,
  });
